
import Vue from 'vue'

const getDefaultState = () => {
    return {
        tutorial: {
            id: 0,
            topic: "",
            listItem: []
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List(_, { idProfile, showOnlyActive = true }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`tutorial/list/${idProfile}/${showOnlyActive}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listTutorial = result.data.result;

                return listTutorial;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list tutorial: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`tutorial/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get tutorial`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get tutorial: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, tutorialRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`tutorial/create-update`, tutorialRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Register updated with success!";

                if (tutorialRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async UpdateStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`tutorial/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.tutorial, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.tutorial;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}